import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CompanyAddressModel } from '../models/companyAddress/company-address-model';
import { DeleteStateCodeModel, ExcludedStateCodeListModel,  ExcludedStateCodeModel, ListStateCodeModel } from '../models/excluded-statecode/excluded-state-code.model';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class ExcludedStatecodeService {

  constructor(private _api: ApiService) { }

  ExcludedStateCodeAdd(excludedStateCode: ExcludedStateCodeModel) {
    return this._api.post(UrlHelperService.excludedStateCodeAdd, excludedStateCode)
  }

  ExcludedStateCodeListing(excludedStateCodeListModel: ListStateCodeModel){
    return this._api.post(UrlHelperService.excludedStateCodeAddListing,excludedStateCodeListModel);
}

 ExcludedStateCodeUpdate(excludedStateCode: ExcludedStateCodeModel) {    
  return this._api.post(UrlHelperService.excludedStateCodeUpdate, excludedStateCode)
}

GetStateCodeById(id) {
  return this._api.get(UrlHelperService. getStateCodeById + id)
}

DeleteStateCode(deleteStateCodeVm: DeleteStateCodeModel ) {
  return this._api.post(UrlHelperService.deleteExcludedStateCode, deleteStateCodeVm)
}

getStateCodeId = new BehaviorSubject(<string>'');
passId(id) {
  this.getStateCodeId.next(id);
}
}
